import { graphql } from "@/lib/gql/__generated__";

export const RoomPriceRank_RoomPriceRankPage_Query = graphql(`
	query RoomPriceRank_RoomPriceRankPage($hotelID: ID!) {
		roomPriceRank(hotelID: $hotelID) {
			id
			hotelID
			ranks {
				priceRankID
				name
				color
				rooms {
					roomID
					roomName
					prices {
						adultNum
						price {
							currencyType
							amount
						}
					}
				}
				isStopSelling
			}
		}
		siteControllerSetting(hotelID: $hotelID) {
			id
			siteControllerType
			setUpRoomPriceByChillnn
		}
	}
`);
